export default "__VITE_ASSET__CGDCqqYz__"